import Vue from 'vue'

Vue.component('carousel-indicator', resolve => {
  resolve({
    props: [
      'total',
      'active'
    ],
    template: `
    <div class="carousel-indicator bg-grey-2">
      <div class="carousel-indicator__bullet bg-blue" :style="{'width': (100 / total)+'%', 'margin-left': (100 / total * active) + '%'}"></div>
    </div>`
  })
})
